import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import OpdekdeurSelfInstallment from "features/option-controls/doors-self-installment/opdekdeur-self-installment";
import SchuifdeurSelfInstallment from "features/option-controls/doors-self-installment/schuifdeur-self-installment";
import TaatsdeurSelfInstallment from "features/option-controls/doors-self-installment/taatsdeur-self-installment";
import SelfInstallmentWarning from "features/option-controls/installment-option-controls/components/self-installment-warning";
import { LeftArrow } from "shared/ui/icons/LeftArrow";
import OptionTemplate from "shared/ui/option-template";
import { DOORS_WITH_ENABLED_INSTALLMENT_TOGGLE } from "widgets/configurator/door-options/SelfAssemblyBlock";
import { OptionModalState } from "widgets/configurator/option-modal";

export const MobileSelfAssemblyPage = ({
  setOptionModalState,
  setSelfAssemblyPageOpen,
}: {
  setOptionModalState: (state: OptionModalState) => void;
  setSelfAssemblyPageOpen: (open: boolean) => void;
}) => {
  const { selfAssembleDoorData, selectedDoor } =
    useConfigurationOptionsContext();
  if (!selectedDoor) return <></>;
  return (
    <>
      <button
        onClick={() => setSelfAssemblyPageOpen(false)}
        className="gg-flex gg-items-center gg-gap-2 gg-rounded-full gg-border gg-border-[#D4D4DA] gg-bg-gray-100 gg-px-4 gg-py-2 gg-text-sm gg-tracking-wider gg-text-[#69687E] hover:gg-bg-gray-200"
      >
        <LeftArrow />
        Naar ontwerpen
      </button>
      {selfAssembleDoorData.selfAssembly && (
        <SelfInstallmentWarning selectedDoor={selectedDoor.code} />
      )}

      {selfAssembleDoorData.selfAssembly === true &&
        DOORS_WITH_ENABLED_INSTALLMENT_TOGGLE.includes(selectedDoor.code) && (
          <OptionTemplate
            title="Afmeting deur"
            description="Om de afmetingen van jouw deur te kunnen bepalen hebben we de afmetingen van jouw deuropening nodig. Je hoeft geen rekening te houden met aftrekmaten of overlap. Die berekenen wij voor je."
            showInfo={false}
            testId="door-self-installment-option"
          >
            {selectedDoor.code === "taatsdeur" ? (
              <TaatsdeurSelfInstallment />
            ) : selectedDoor.code === "opdekdeur" ? (
              <OpdekdeurSelfInstallment
                onShowInfoClick={({ title, description }) =>
                  setOptionModalState({
                    isOpen: true,
                    heading: title,
                    description: description,
                  })
                }
              />
            ) : selectedDoor.code === "schuifdeur" ? (
              <SchuifdeurSelfInstallment
                onShowInfoClick={({ title, description }) =>
                  setOptionModalState({
                    isOpen: true,
                    heading: title,
                    description: description,
                  })
                }
              />
            ) : (
              <></>
            )}
          </OptionTemplate>
        )}
    </>
  );
};
